import { valueof } from 'src/Library/Types';
import * as routingUtils from 'src/routing/utils';
import * as partsConstants from '../../utils/partsToShow/partsConstants';

const getCustomerSectionTitle = () => {
  const {
    localStorage: { type },
  } = window;
  return type === 'FF' ? 'My Shipper' : 'My Customers';
};

const getTabKey = () => {
  const {
    localStorage: { type },
  } = window;
  return type === 'FF' ? 'SHIPPER' : 'CUSTOMER';
};

export type GetPartsMapReturnType = {
  [key in valueof<typeof partsConstants>]:
  {
    route: string;
    rootTitle: string;
    hideOnMobile?: boolean;
    sectionTitle?: string;
    description?: string;
  }
};

export const getPartsMap = (permissionModules, type): Partial<GetPartsMapReturnType> => {
  return {
    [partsConstants.PLAY]: {
      rootTitle: 'Play',
      hideOnMobile: true,
      route: routingUtils.getPlayRoute(),
    },
    // [partsConstants.SUMMARY_DASHBOARD]: {
    //   rootTitle: 'Summary Dashboard',
    //   sectionTitle: 'Summary Dashboard',
    //   hideOnMobile: false,
    //   route: routingUtils.getSummaryDashboardRoute(),
    // },
    [partsConstants.EXCEPTION_RULES]: {
      rootTitle: 'Exception Rules',
      route: routingUtils.getExceptionRulesRoute(),
    },
    [partsConstants.EXCEPTION_ALERT_DEFINITIONS]: {
      rootTitle: 'Exception Alert Definitions',
      sectionTitle: 'Alerts Definitions',
      route: routingUtils.getAlertDefinitionsRoute(),
    },
    [partsConstants.EXCEPTION_ALERT_INSTANCES]: {
      rootTitle: 'Exception Alert Instances',
      sectionTitle: 'Alert Instances',
      route: routingUtils.getAlertInstancesRoute(),
    },
    [partsConstants.EXPORTS_RAKE]: {
      rootTitle: 'Exports Rake',
      sectionTitle: 'Rake',
      route: routingUtils.getRakeRoute(),
    },
    [partsConstants.EXPORTS_SALES_ORDER]: {
      rootTitle: 'Exports Sales Order',
      sectionTitle: 'Sales Order',
      route: routingUtils.getSalesOrderRoute('export'),
    },
    [partsConstants.IMPORTS_RAKE]: {
      rootTitle: 'Imports Rake',
      sectionTitle: 'Rake',
      route: routingUtils.getRakeRoute(),
    },
    [partsConstants.IMPORTS_SALES_ORDER]: {
      rootTitle: 'Imports Sales Order',
      sectionTitle: 'Sales Order',
      route: routingUtils.getSalesOrderRoute('import'),
    },
    [partsConstants.DOMESTIC_TRACKING]: {
      rootTitle: 'Domestic',
      sectionTitle: 'Tracking',
      route: routingUtils.getDomesticTrackRoute(),
    },
    [partsConstants.DOMESTIC_CARRIER_MANAGEMENT]: {
      rootTitle: 'Domestic',
      sectionTitle: 'Carrier Management',
      route: routingUtils.getDomesticCarrierManagementRoute(),
    },
    [partsConstants.CUSTOMER_ACTIVITY]: {
      rootTitle: 'Domestic',
      sectionTitle: 'Customer Activity',
      route: routingUtils.getCustomerActivityRoute(),
    },
    [partsConstants.CONTAINER_TRACKING]: {
      rootTitle: 'Track Shipments',
      sectionTitle: 'Container Tracking',
      route: routingUtils.getContainerTrackingRoute(null, 'container'),
      description:
        'A Real-time visibility tool. Track containers (BL, Booking, Container No.) and air shipments (AWB), view their location, milestones and delays',
    },
    [partsConstants.IMPORTS_CONTAINER_TRACKING]: {
      rootTitle: 'Track Shipments',
      sectionTitle: 'Container Tracking',
      route: routingUtils.getContainerTrackingRoute('import'),
      description:
        'A Real-time visibility tool. Track containers (BL, Booking, Container No.) and air shipments (AWB), view their location, milestones and delays',
    },
    [partsConstants.EXPORTS_CONTAINER_TRACKING]: {
      rootTitle: 'Track Shipments',
      sectionTitle: 'Container Tracking',
      route: routingUtils.getContainerTrackingRoute('export'),
      description:
        'A Real-time visibility tool. Track containers (BL, Booking, Container No.) and air shipments (AWB), view their location, milestones and delays',
    },
    [partsConstants.INQUIRY_SHIPPER]: {
      rootTitle: 'Rate Inquiry',
      sectionTitle: 'Rate Inquiry',
      route: routingUtils.getInquiryShipperRoute(),
      description:
        'Short-term request for rates. Use this module when you need freight rates for a single shipment or lane and run competitive bidding with vendors.',
    },
    [partsConstants.INQUIRY_FF]: {
      rootTitle: 'Quote',
      sectionTitle: 'Quote',
      route: routingUtils.getInquiryFFRoute(),
      description:
        'Respond to shipper inquiries with quotes and manage bookings to secure deals',
    },
    [partsConstants.SHIP_EXEC_SHIPPER]: {
      rootTitle: 'Manage Tasks',
      sectionTitle: 'Shipper',
      route: routingUtils.getShipmentsListRoute('shipper'),
      description:
        'A workflow execution and compliance tool. Manage shipment tasks such as document uploads, approvals, and operational milestones',
    },
    [partsConstants.SHIP_EXEC_VENDOR]: {
      rootTitle: 'Manage Tasks',
      sectionTitle: 'Vendor',
      route: routingUtils.getShipmentsListRoute('ff'),
      description:
        'A workflow execution and compliance tool. Manage shipment tasks such as document uploads, approvals, and operational milestones',
    },
    [partsConstants.IMPORTS]: {
      rootTitle: 'Imports',
      sectionTitle: 'Bulk/Break Bulk',
      route: routingUtils.getImportRoute(),
    },
    [partsConstants.EXPORTS]: {
      rootTitle: 'Exports',
      sectionTitle: 'Exports',
      route: routingUtils.getExportsRoute(),
    },
    [partsConstants.AIR_CARGO]: {
      rootTitle: 'Air Cargo',
      sectionTitle: 'Air Cargo',
      route: routingUtils.getFreightForwardedRoute(), //TODO We need to make this configurable
    },
    [partsConstants.TRIANGULATION]: {
      rootTitle: 'Container Triangulation',
      sectionTitle: 'Container Triangulation',
      route: routingUtils.getTriangulationRoute(),
      description: 'Connect with Importers if containers not available at Yard',
    },
    [partsConstants.API]: {
      rootTitle: 'API Documentation',
      sectionTitle: 'API Documentation',
      route: routingUtils.getApiDocsRoute(),
    },
    [partsConstants.CUSTOM_CONFIG]: {
      rootTitle: 'Custom Configurations',
      sectionTitle: 'Custom Configurations',
      route: routingUtils.getCustomConfigRoute(),
    },
    [partsConstants.RFQ_SHIPPER_OCEAN_FREIGHT]: {
      rootTitle: 'RFQ Plans',
      sectionTitle: 'RFQ Plans',
      route: routingUtils.getRFQAllPlansRoute(),
    },
    [partsConstants.RFQ_RATE_MASTER]: {
      rootTitle: 'RFQ Rate Master',
      sectionTitle: 'RFQ Rate Master',
      route: routingUtils.getRfqLocalRateMasterRoute(),
    },
    [partsConstants.RFQ_SHIPPER_ANALYTICS]: {
      rootTitle: 'Analytics',
      sectionTitle: 'Analytics',
      description:
        'A business intelligence and analytics module. Use this to create and view dashboards, KPIs, and reports across inquiries, bookings, RFQs, shipments, and invoices',
      route: routingUtils.getRfqAnalyticsRoute(),
    },
    [partsConstants.MY_PROFILE]: {
      rootTitle: 'My Account',
      sectionTitle: 'My Account',
      route: routingUtils.getAccountRoute(),
    },
    [partsConstants.MY_ORGANISATION]: {
      rootTitle: 'My Organisation',
      sectionTitle: 'My Organisation',
      route: routingUtils.getOrganisationRoute(),
    },
    [partsConstants.MY_SUBSCRIPTION_PLAN]: {
      rootTitle: 'My Subscription Plan',
      sectionTitle: 'My Subscription Plan',
      route: routingUtils.getSubscriptionPlanRoute(),
    },
    [partsConstants.LOGOUT]: {
      rootTitle: 'Logout',
      sectionTitle: 'Logout',
      route: routingUtils.getLogoutRoute(),
    },
    [partsConstants.HOME]:{
      rootTitle: 'Home',
      sectionTitle: 'Home',
      route: routingUtils.getHomeRoute(),
      description: 'Home',
    },
    // [partsConstants.RFQ_SHIPPER]: {
    //   rootTitle: 'RFQ',
    //   onClick: ({ history }) => history.push(routingUtils.getRFQAllPlansRoute()),
    // },
    [partsConstants.RFQ_SHIPPING_LINE]: {
      rootTitle: 'Bidding',
      sectionTitle: 'RFQ Bidding',
      route: routingUtils.getBiddingAllPlansRoute(),
    },
    [partsConstants.RFQ_VENDOR]: {
      rootTitle: 'RFQ (Vendor)',
      sectionTitle: 'RFQ Vendor',
      route: routingUtils.getRFQVendorRoute(),
    },
    [partsConstants.RATE_MASTER]: {
      rootTitle: 'Rate Master',
      sectionTitle: 'Rate Master',
      route: routingUtils.getRateMasterRoute(),
      description:
        'A storage library for all rates. Use this module to upload and store offline rate sheets or view confirmed bids that are auto-captured into your system',
    },
    [partsConstants.SETUP_USERS]: {
      rootTitle: 'User Management',
      sectionTitle: 'User Management',
      route: routingUtils.getUserManagementRoute(),
    },
    [partsConstants.SETUP_TEAMS]: {
      rootTitle: 'Team Management',
      sectionTitle: 'Team Management',
      route: routingUtils.getTeamManagementRoute(),
    },
    [partsConstants.SETUP_PERMISSIONS]: {
      rootTitle: 'Permissions',
      sectionTitle: 'Permissions',
      route: routingUtils.getPermissionsRoute(),
    },
    [partsConstants.SETUP_TNC]: {
      rootTitle: 'Terms & Conditions',
      sectionTitle: 'Terms & Conditions',
      route: routingUtils.getTnCRoute(),
    },
    [partsConstants.SETUP_CHARGE_MASTER]: {
      rootTitle: 'My Charge Master',
      sectionTitle: 'My Charge Master',
      route: routingUtils.getChargeMasterRoute(),
    },
    [partsConstants.APPROVAL_POLICIES]: {
      rootTitle: 'Approval Policies',
      sectionTitle: 'Approval Policies',
      route: routingUtils.getApprovalPoliciesRoute(),
      description:
        'Configure who approves what and when — levels, criteria and approvers for the approval engine.',
    },
    [partsConstants.MY_APPROVALS]: {
      rootTitle: 'My Approvals',
      sectionTitle: 'My Approvals',
      route: routingUtils.getMyApprovalsRoute(),
      description: 'Approval requests waiting on you — review and open the item to act.',
    },
    // [partsConstants.SETUP_MASTERS]: {
    //   rootTitle: 'Masters',
    //   sectionTitle: 'Masters',
    //   route: routingUtils.getSetupMastersRoute(''),
    // },
    [partsConstants.MY_SHIPPING_LINE]: {
      rootTitle: 'My Shipping Lines',
      sectionTitle: 'My Shipping Lines',
      route: routingUtils.getSetupMastersRoute('SHIPPING_LINE'),
    },
    [partsConstants.MY_CHA]: {
      rootTitle: 'My CHAs',
      sectionTitle: 'My CHAs',
      route: routingUtils.getSetupMastersRoute('CHA'),
    },
    [partsConstants.MY_FF]: {
      rootTitle: 'My Vendors',
      sectionTitle: 'My Vendors',
      route: routingUtils.getSetupMastersRoute('VENDOR'),
    },
    [partsConstants.MY_SHIPPER]: {
      rootTitle: 'My Shippers',
      sectionTitle: 'My Shippers',
      route: routingUtils.getSetupMastersRoute('SHIPPER'),
    },
    [partsConstants.MY_CHILD]: {
      rootTitle: 'My Child Stakeholders',
      sectionTitle: 'My Child Stakeholders',
      route: routingUtils.getSetupMastersRoute('CHILD'),
    },
    [partsConstants.MY_CUSTOMER]: {
      rootTitle: 'My Customers',
      sectionTitle: 'My Customers',
      route: routingUtils.getSetupMastersRoute('CUSTOMER'),
    },
    [partsConstants.MY_SUPPLIER]: {
      rootTitle: 'My Suppliers',
      sectionTitle: 'My Suppliers',
      route: routingUtils.getSetupMastersRoute('SUPPLIER'),
    },
    [partsConstants.PRODUCT]: {
      rootTitle: 'My Products',
      sectionTitle: 'My Products',
      route: routingUtils.getSetupMastersRoute('PRODUCT'),
    },
    [partsConstants.ADDRESS]: {
      rootTitle: 'My Addresses',
      sectionTitle: 'My Addresses',
      route: routingUtils.getSetupMastersRoute('ADDRESS'),
    },
    [partsConstants.MY_DOCUMENTS]: {
      rootTitle: 'My Documents',
      sectionTitle: 'My Documents',
      route: routingUtils.getSetupMastersRoute('DOCUMENT'),
    },
    [partsConstants.REGIONS]: {
      rootTitle: 'Regions Template',
      sectionTitle: 'Regions Template',
      route: routingUtils.getMyRegionstemplateRoute(),
    },
    [partsConstants.PAYABLE]: {
      rootTitle: 'Payables',
      sectionTitle: 'Payables',
      route: routingUtils.getInvoicingRoute('payables'),
      description:
        'Manage Payables & Receivables: create, compare, approve, dispute, track all your invoices',
    },
    [partsConstants.RECEIVABLE]: {
      rootTitle: 'Receivables',
      sectionTitle: 'Receivables',
      route: routingUtils.getInvoicingRoute('receivables'),
      description:
        'Manage Payables & Receivables: create, compare, approve, dispute, track all your invoices',
    },
    [partsConstants.BULK_REQUEST]: {
      rootTitle: 'Bulk Request',
      sectionTitle: 'Bulk Request',
      route: routingUtils.getBulkRequestRoute(),
      description: 'Check the status of your bulk uploads and downloads',
    },
    [partsConstants.DSR_TEMPLATES]: {
      rootTitle: 'DSR Templates',
      sectionTitle: 'DSR Templates',
      route: routingUtils.getDsrTemplateRoute(),
    },
    [partsConstants.DEMURRAGE_AND_DETENTION]: {
      rootTitle: 'Demurrage & Detention',
      sectionTitle: 'Demurrage & Detention',
      route: routingUtils.getDemurrageDetentionRoute(),
    },
    [partsConstants.MARKUP_AUTOMATION_TOOL]: {
      rootTitle: 'Markup Automation Tool',
      sectionTitle: 'Markup Automation Tool',
      route: routingUtils.getMarkupAutomationToolRoute(),
    },
    [partsConstants.TASKS_WORKFLOW]: {
      rootTitle: 'Tasks Workflow',
      sectionTitle: 'Tasks Workflow',
      route: routingUtils.getTasksWorkflowRoute(),
    },
    [partsConstants.PORT_GROUPS]: {
      rootTitle: 'Port Groups',
      sectionTitle: 'Port Groups',
      route: routingUtils.getPortGroupsRoute(),
      description: 'Create and manage port groups for easy selection in your shipments',
    },
    ...(type === 'FF' && {
      ...(!(
        permissionModules?.show_discover_buy_rates && permissionModules?.show_discover_sell_rates
      ) && {
        [partsConstants.DISCOVER_SELL_RATES]: {
          rootTitle: 'Contract Rates',
          sectionTitle: 'Contract Rates',
          route: routingUtils.getDiscoverRatesRoute('sell'),
          description:
            'Live search & booking tool. Search confirmed rates, filter by route, carrier, validity, get trends & raise a booking request directly',
        },
      }),
      [partsConstants.DISCOVER_BUY_RATES]: {
        rootTitle: 'Contract Rates',
        sectionTitle: 'Contract Rates',
        route: routingUtils.getDiscoverRatesRoute('buy'),
        description:
          'Live search & booking tool. Search confirmed rates, filter by route, carrier, validity, get trends & raise a booking request directly',
      },
    }),
    ...(type === 'SHIPPER' && {
      [partsConstants.DISCOVER_RATES]: {
        rootTitle: 'Contract Rates',
        sectionTitle: 'Contract Rates',
        route: routingUtils.getDiscoverRatesLandingPageRoute(),
        description:
          'Live search & booking tool. Search confirmed rates, filter by route, carrier, validity, get trends & raise a booking request directly',
      },
    }),
    [partsConstants.VESSEL_SCHEDULES]: {
      rootTitle: 'Vessel Schedules',
      sectionTitle: 'Vessel Schedules',
      route: routingUtils.getVesselSchedulesRoute(),
      description: 'Check the global sailing schedules to plan your shipments',
    },
    [partsConstants.ANALYTICS]: {
      rootTitle: 'Shipsy BI(Insights)',
      sectionTitle: 'Analytics',
      description:
        'A business intelligence and analytics module. Use this to create and view dashboards, KPIs, and reports across inquiries, bookings, RFQs, shipments, and invoices',
      route: routingUtils.getAnalyticsRoute(),
    },
  };
};
